<template>
    <v-dialog
        v-model="visible"
        max-width="30em"
        @click:outside="$emit('close')"
    >
        <v-card class="overflow-hidden">
            <v-card-title class="justify-space-between">
                <span class="headline">Payment Details </span>

                <v-icon
                    class="close"
                    @click="$emit('close')"
                >
                    mdi-close
                </v-icon>
            </v-card-title>

            <v-container>
                <v-row class="fill-height overflow-auto">
                    <v-col cols="12">
                        <div class="item-img text-center">
                            <v-avatar
                                size="150"
                                color="primary"
                            >
                                <v-img
                                    :src="details.avatar"
                                    height="150"
                                />
                            </v-avatar>
                            <div class="item-details mt-3">
                                <h3>{{ details.name }}</h3>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div class="item-details px-5">
                            <h3>Information</h3>
                            <div class="description">
                                <p class="mr-3">
                                    Company:
                                </p>
                                <p>{{ healthInsuranceProvider.name }}</p>
                            </div>
                            <div class="description">
                                <p class="mr-3">
                                    Insurance Cost:
                                </p>
                                <p>${{ formatAmount(healthInsurancePlan.price) }}</p>
                            </div>
                            <!-- <div class="description">
                                <p class="mr-3">
                                    Insurance Type:
                                </p>
                                <p>{{ details.package ? 'Individual' : 'Family' }}</p>
                            </div> -->

                            <div class="d-flex mt-5">
                                <v-icon
                                    color="green"
                                    class="mr-5 mt-n5"
                                >
                                    mdi-check-circle-outline
                                </v-icon>
                                <p class="subtitle-1 mb-0">
                                    Kindly make payment to the health insurance provider with the following details:
                                </p>
                            </div>

                            <v-sheet
                                tile
                                color="grey lighten-2"
                                class="py-6 px-3 my-3 grey--text text--darken-3 rounded-lg"
                            >
                                <FieldName
                                    v-if="recipientInfo.name"
                                    :recipient-info="recipientInfo"
                                />
                                <FieldBankName
                                    v-if="recipientInfo.bank_name"
                                    :recipient-info="recipientInfo"
                                />
                                <FieldAccountNumber
                                    v-if="recipientInfo.account_number"
                                    :recipient-info="recipientInfo"
                                />
                                <FieldPhone
                                    v-if="recipientInfo.phone"
                                    :recipient-info="recipientInfo"
                                />
                                <FieldEmail
                                    v-if="recipientInfo.email"
                                    :recipient-info="recipientInfo"
                                />
                                <FieldCity
                                    v-if="recipientInfo.city"
                                    :recipient-info="recipientInfo"
                                />
                            </v-sheet>

                            <div class="text-center mt-5">
                                <v-btn
                                    color="primary"
                                    dark
                                    depressed
                                    style="height: 43px"
                                    @click="pay"
                                >
                                    Pay
                                </v-btn>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
    /* eslint-disable camelcase */
    import FormFillerService from '../../../services/FormFillerService';

    import FieldName from '../../match-confirmed-reveal-field-name.vue';
    import FieldBankName from '../../match-confirmed-reveal-field-bank-name.vue';
    import FieldAccountNumber from '../../match-confirmed-reveal-field-account-number.vue';
    import FieldPhone from '../../match-confirmed-reveal-field-phone.vue';
    import FieldEmail from '../../match-confirmed-reveal-field-email.vue';
    import FieldCity from '../../match-confirmed-reveal-field-city.vue';

    export default {
        components: {
            FieldName,
            FieldBankName,
            FieldAccountNumber,
            FieldPhone,
            FieldEmail,
            FieldCity,
        },
        props: {
            visible: Boolean,
            details: {
                type: Object,
                default: () => ({}),
            },
        },
        computed: {
            healthInsurancePlan() {
                return this.details.healthInsurancePlan || {};
            },
            healthInsuranceProvider() {
                return this.healthInsurancePlan.healthInsuranceProvider || {};
            },
            user() {
                return this.healthInsuranceProvider.user || {};
            },
            deliveryMethods() {
                return this.healthInsuranceProvider.deliveryMethods || [];
            },
            deliveryMethod() {
                return this.deliveryMethods[0] || {};
            },
            recipientInfo() {
                const {
                    email,
                    phone,
                    city,
                } = this.user;

                const {
                    accountName,
                    accountNumber,
                    bankCode,
                    bankName,
                } = this.deliveryMethod;

                return {
                    name: accountName,
                    account_number: accountNumber,
                    bank_name: bankName,
                    bank_code: bankCode,
                    email,
                    phone,
                    city,
                };
            },
        },
        methods: {
            // FIXME: remove default worldremit
            async pay({ url = 'https://www.worldremit.com/en' }) {
                let { details } = this;
                const {
                    id: health_insurance_enrollee_id,
                    initiatedPayment,
                } = details;

                let paymentId = null;

                if (initiatedPayment && initiatedPayment.id) {
                    paymentId = initiatedPayment.id;
                } else {
                    const { data } = await Vue.backendApi()
                        .healthInsurancePayments()
                        .create({
                            health_insurance_enrollee_id,
                        });
                    paymentId = data.id;

                    const { data: newDetails } = await Vue.backendApi()
                        .healthInsuranceEnrollees()
                        .get(health_insurance_enrollee_id);

                    details = newDetails;
                }

                await FormFillerService.dispatchPaymentEvent(paymentId, 'health-insurance', url);

                this.popupCenter(url);

                this.$emit('pay', details);

                // TODO: Handle errors
            },
        },
    };
</script>

<style scoped>
.item-img img {
    width: 150px;
    height: 150px;
}

.close {
    position: absolute;
    right: 0;
    top: 0;
    padding: 5px;
    cursor: pointer;
}

.item-details h3 {
        color: #232323;
    font-size: 20px;
    line-height: 22px;
    font-weight: 500;
}

.item-details .title p {
    color: #232323;
    font-weight: 400;
    font-size: 18px;
    margin: 0;
}

.item-details .description {
    border-top: 1px solid #e8e8e8;
    margin: 0px 0 15px;
    display: flex;
    padding: 23px 0 0 0;
    line-height: 23px;
    font-weight: 400;
}

.item-details .description p {
    margin: 0;
    padding: 0;
}

</style>
